import React, { useState } from 'react';
import {
    Box,
    Button,
    InputAdornment,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import TableDownloadBtn from '../../components/dropdown-select/TableDownloadBtn';
import ImportMember from './ImportMember';

import TeamOnboarding from '../../components/Projects/TeamOnboarding';
import InviteMembers from '../../components/Projects/InviteMembers';



import { SettingsIcon, FilterIcon, DownloadIcon, UsersIcon } from '../../icons';
import ManualTable from './ManualTable';
import data from './data'; // make sure this contains all rows
import FilterSidebar from './FilterSidebar';

function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Members = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Filter logic for tabs
    const activeMembers = data.filter((row) => row.status === 'Active');
    const inviteMembers = data.filter((row) => row.status !== 'Active');

    const membersCount = activeMembers.length;
    const invitesCount = inviteMembers.length;
    const [filterOpen, setFilterOpen] = useState(false);

    const [openImportProject, setOpenImportProject] = useState(false);
    const [openTeamOnboarding, setOpenTeamOnboarding] = useState(false);
    const [openInviteMembers, setOpenInviteMembers] = useState(false);




    return (
        <>
            <Box>
                <Typography variant="h6" fontWeight="600" sx={{ fontSize: '24px', mb: 1 }}>
                    Members
                </Typography>
                <Box className="d-flex gap-10 align-items-center mb-3" sx={{ flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }, justifyContent: 'space-between' }}>
                    <Box sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}>
                        <TextField sx={{ width: '100%' }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: {
                                    borderRadius: '20px',
                                    background: '#fff',
                                    fontSize: '13px',
                                    minWidth: { xl: '450px', lg: '240px', md: '200px', sm: '100%', xs: '100%' },
                                },
                            }}
                        />
                    </Box>
                    <Box sx={{
                        overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                        maxWidth: '100%',
                    }}>
                        <Box display="inline-flex"
                            gap={1}
                            mb={0}
                            sx={{
                                flexWrap: 'nowrap',
                                minWidth: 'max-content',
                            }}>
                            {value === 0 && (<Tooltip title="Download" arrow placement="top"><Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '14px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><TableDownloadBtn /></Button></Tooltip>)}
                            {value === 0 && (<Tooltip title="Filter" arrow placement="top"><Button onClick={() => setFilterOpen(true)} sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '14px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><FilterIcon /></Button></Tooltip>)}
                            <Button onClick={() => setOpenImportProject(true)} sx={{ background: '#fff', px: '16px', borderRadius: '50px', color: '#0076FE', fontSize: '14px', textTransform: 'capitalize', height: '40px', border: '1px solid #E5E8EB', }}>Import Member</Button>
                            <Button onClick={() => setOpenTeamOnboarding(true)} sx={{ background: '#fff', px: '16px', borderRadius: '50px', color: '#0076FE', fontSize: '14px', textTransform: 'capitalize', height: '40px', border: '1px solid #E5E8EB', }}><UsersIcon className="me-10" /> Onboarding Status </Button>
                            {value === 0 && (<Button onClick={() => setOpenInviteMembers(true)} sx={{ background: '#0076FE', px: '16px', borderRadius: '50px', color: '#fff', fontSize: '14px', textTransform: 'capitalize', height: '40px', border: '1px solid #E5E8EB', boxShadow: 'none', }}>+  Members</Button>)}
                            {value === 1 && (<Button onClick={() => setOpenInviteMembers(true)} sx={{ background: '#0076FE', px: '16px', borderRadius: '50px', color: '#fff', fontSize: '14px', textTransform: 'capitalize', height: '40px', border: '1px solid #E5E8EB', boxShadow: 'none', }}>Invite Members</Button>)}
                            <Link to='/general'>
                                <Tooltip title="Settings" arrow placement="top"><Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button></Tooltip>
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <ImportMember open={openImportProject} onClose={() => setOpenImportProject(false)} />
            <TeamOnboarding open={openTeamOnboarding} onClose={() => setOpenTeamOnboarding(false)} />
            <InviteMembers open={openInviteMembers} onClose={() => setOpenInviteMembers(false)} />
            {/* Tabs */}
            <Box sx={{ display: 'inline-block' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" TabIndicatorProps={{ style: { display: 'none' } }}
                    sx={{
                        minHeight: 'auto',
                        display: 'flex',
                        gap: '15px',
                    }}>
                    <Tab label={`Members (${membersCount})`} {...a11yProps(0)} sx={{
                        textTransform: 'none',
                        minHeight: 'auto',
                        px: 3,
                        py: 1,
                        borderRadius: '60px',
                        fontWeight: 500,
                        color: '#64748B',
                        border: '1px solid #D9D9D9',
                        background: '#FFF',
                        '&.Mui-selected': {
                            color: '#fff',
                            background: '#004DFF', // Change to your active color
                            border: '1px solid #004DFF',
                        },
                    }} />
                    <Tab label={`Invites (${invitesCount})`} {...a11yProps(1)} sx={{
                        textTransform: 'none',
                        minHeight: 'auto',
                        marginLeft: '15px',
                        px: 3,
                        py: 1,
                        borderRadius: '60px',
                        fontWeight: 500,
                        color: '#64748B',
                        border: '1px solid #D9D9D9',
                        background: '#FFF',
                        '&.Mui-selected': {
                            color: '#fff',
                            background: '#004DFF',
                            border: '1px solid #004DFF',
                        },
                    }} />
                </Tabs>
            </Box>


            {/* Members Tab */}
            <CustomTabPanel value={value} index={0}>
                <ManualTable
                    isMembersView={true}
                    isInviteView={false}
                    data={activeMembers}
                />
            </CustomTabPanel>

            {/* Invites Tab */}
            <CustomTabPanel value={value} index={1}>
                <ManualTable
                    isMembersView={false}
                    isInviteView={true}
                    data={inviteMembers}
                />
            </CustomTabPanel>


            <FilterSidebar open={filterOpen} onClose={() => setFilterOpen(false)} />
        </>
    );
};

export default Members;
